import { isEmptyHTML } from "./htmlUtils";

export function showAboutUs(pageData) {
  return (
    !isEmptyHTML(pageData.aboutUs) ||
    !isEmptyHTML(pageData.ourMission) ||
    !isEmptyHTML(pageData.ourVision)
  );
}
